import { useEffect } from 'react';

import { getCookie } from '@api/HelperAPI';
import { tracking } from '@iwoca/frontend-tracking-library';
import { RootState } from '@iwProvider/configureStore';
import _ from 'lodash';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import messages from './EndedView.messages';
import styles from './EndedView.module.css';
import NewLoanEndedView from './NewLoanEndedView';
import TopUpEligibilitySection from './TopUpEligibilitySection';
import {
    getApplicantFirstName,
    getApplicantLastName,
    getApplicantTitle
} from '../../../api/lendingAPI/CustomerStateAPIHelper';
import { TProductType } from '../../../myAccount/dashboard/Dashboard.types';
import { MainSectionWrapper } from '../../pageStructure/mainSectionWrapper/index';

const mapStateToProps = (state: RootState) => {
    return {
        firstName: getApplicantFirstName(state.api.customer_state.data),
        lastName: getApplicantLastName(state.api.customer_state.data),
        title: _.upperFirst(getApplicantTitle(state.api.customer_state.data))
    };
};

type PropsFromRedux = ReturnType<typeof mapStateToProps>;

const EndedView = ({
    accountId,
    productType,
    firstName,
    lastName,
    title
}: PropsFromRedux & {
    accountId: string;
    productType: Exclude<TProductType, undefined | null>;
}) => {
    useEffect(() => {
        tracking.ampli.dashboardViewed({
            account_id: accountId,
            // @ts-expect-error Ampli type doesn't have term_loan. Needs adding
            product_type: productType,
            dashboard_state: 'ended'
        });
    }, [accountId, productType]);

    const shouldSeeNewLoanEndedView =
        productType !== 'merchant_cash_advance' &&
        getCookie('showOldLoanEndedView') !== 'true';

    return (
        <MainSectionWrapper
            className={styles.loanEndedWrapperTopUp}
            innerWrapperClassName={styles.loanEndedTopupInnerWrapper}
        >
            {shouldSeeNewLoanEndedView ? (
                <NewLoanEndedView accountId={accountId} />
            ) : (
                <>
                    <h1
                        className={styles.welcomeMessage}
                        data-testid="welcome-message"
                    >
                        <FormattedMessage
                            {...messages.welcomeBack}
                            values={{
                                firstName,
                                lastName,
                                title
                            }}
                        />
                    </h1>
                    <TopUpEligibilitySection />
                </>
            )}
        </MainSectionWrapper>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(EndedView);
